<template>
    <log-list :category="null" />
</template>

<script lang="ts">
import LogList from "@/components/log/log.vue";
import {Vue, Component} from 'vue-property-decorator';

@Component({
    components: {LogList}
})
export default class LogDB extends Vue {

}
</script>